import ArrowWithoutTail from '@/assets/ArrowWithoutTail';
import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Drawer,
	DrawerProps,
} from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { ReactElement, useEffect, useState } from 'react';
import { Faq } from '@/models/generics';
import { emitMoeEvent } from '@/utils/dataLayer';

type FaqsDrawerProps = {
	drawerProps?: DrawerProps;
	title: ReactElement;
	faqs: Faq[];
};

const FaqsDrawer = (props: FaqsDrawerProps) => {
	const [expandedFaq, setExpandedFaq] = useState<string | false>('panel0');
	const expandFaqAnswer =
		(panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
			setExpandedFaq(newExpanded ? panel : false);
		};

	useEffect(() => {
		if (props.drawerProps?.open) {
			emitMoeEvent('Info Bottomsheet Opened', {
				heading: props.title,
			});
		}
	}, [props.drawerProps?.open]);

	return (
		<Drawer {...props.drawerProps}>
			<Box mt='40px'>
				<Box sx={{ borderRadius: '24px ' }}>
					<FlexBox
						sx={{
							justifyContent: 'space-between',
						}}
					>
						{props?.title}
					</FlexBox>

					<Box>
						{props?.faqs?.map((d: any, index: number) => (
							<FlexBox
								key={d.question}
								sx={{
									justifyContent: 'start',
									width: '100%',
									alignItems: 'flex-start',
									mt: '10px',
								}}
							>
								<Accordion
									expanded={expandedFaq === `panel${index}`}
									onChange={expandFaqAnswer(`panel${index}`)}
									sx={{ boxShadow: 'none', padding: '0' }}
								>
									<AccordionSummary
										sx={{ padding: '0', display: 'flex' }}
										aria-controls={`panel${index}d-content`}
										id={`panel${index}d-header`}
									>
										<FlexBox
											fullWidth
											justifyContent={'space-between'}
											alignItems={'flex-start'}
											sx={{ marginBottom: '-20px' }}
										>
											<LencoTypography sx={{ ...getStyle('P_Medium') }}>
												{d.question}
											</LencoTypography>
											<Box
												sx={{
													transform:
														expandedFaq === `panel${index}`
															? 'rotate(180deg)'
															: 'rotate(0deg)',
												}}
											>
												<ArrowWithoutTail color={getColor('Gray -2')} />
											</Box>
										</FlexBox>
									</AccordionSummary>
									<AccordionDetails sx={{ p: 0, mt: 0 }}>
										<LencoTypography
											sx={{
												...getStyle('Small_Regular'),
												color: getColor('Gray -2'),
											}}
										>
											{d?.answer}
										</LencoTypography>
									</AccordionDetails>
								</Accordion>
							</FlexBox>
						))}
					</Box>
				</Box>
			</Box>
		</Drawer>
	);
};

export default FaqsDrawer;
